import * as Yup from "yup";
import { REQUIRED_FIELD } from "constants/validator-messages";

export const SmeSyncValidationSchema = (isApplicant: boolean) => {
  return Yup.object().shape({
    building_name: Yup.string(),
    building_number: isApplicant
      ? Yup.string()
      : Yup.string().required(REQUIRED_FIELD),
    address_line_one: isApplicant
      ? Yup.string()
      : Yup.string().required(REQUIRED_FIELD),
    address_line_two: Yup.string(),
    address_line_three: Yup.string(),
    address_line_four: Yup.string(),
    postcode: isApplicant
      ? Yup.string()
      : Yup.string().required(REQUIRED_FIELD),
  });
};

export const SmeDuplicateValidationSchema = Yup.object().shape({
  leadId: Yup.number().nullable(true),
});
